<template>
  <div id="app" >
    <router-view/>
    <Logins v-if="login_Type" />
    <Floating />
  </div>
</template>
<script>
import Logins from '@/components/Logins.vue'
import Floating from '@/components/Floating.vue'
import { captureChannelFromVisit } from '@/utils/channelData.js'
export default {
  components: {
    Logins,
    Floating
  },
  data(){
    return {
      login_Type:false,
    }
  },
  computed:{
    LoginType(){
      return this.$store.state.loginType
    }
  },
  watch:{
    'LoginType':{
      handler(value){
        this.login_Type = value
      },
      immediate: true,
			deep: true 
    }
  },
  mounted(){
    captureChannelFromVisit()
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
